import type { TourConfig } from './types';

export const settingsTour: TourConfig = {
  id: 'settings-page',
  name: 'Settings Tour',
  description: 'Learn about the settings options available',
  requiredPath: '/dashboard/settings',
  steps: [
    {
      element: '[data-tour="settings-general"]',
      popover: {
        title: 'General Settings',
        description:
          'Update your personal account information and profile settings.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="settings-organization"]',
      popover: {
        title: 'Organization Settings',
        description:
          'Manage your organization name, logo, and contact information that appears on client documents.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="settings-users"]',
      popover: {
        title: 'User Management',
        description:
          'Invite team members, manage user accounts, and control access to your organization.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="settings-roles"]',
      popover: {
        title: 'Roles & Permissions',
        description:
          'Create custom roles and configure granular permissions for different team members.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="settings-audit"]',
      popover: {
        title: 'Audit Logs',
        description:
          'Track all actions performed in your organization for security and compliance.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="settings-integrations"]',
      popover: {
        title: 'Integrations',
        description:
          'Connect third-party services like Google Calendar to enhance your workflow.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="settings-billing"]',
      popover: {
        title: 'Billing',
        description:
          'View your subscription status, payment history, and manage billing details.',
        side: 'bottom',
        align: 'end',
      },
    },
  ],
};
